export const LOAD_PAPERWORK_LIST = 'paperwork/LOAD_PAPERWORK_LIST';
export const LOAD_PAPERWORK_LIST_SUCCESS =
  'paperwork/LOAD_PAPERWORK_LIST_SUCCESS';
export const LOAD_PAPERWORK_LIST_ERROR = 'paperwork/LOAD_PAPERWORK_LIST_ERROR';
